var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3239_13478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64936 21.9076H14.8756C15.4231 21.9076 15.8731 21.4614 15.8731 20.9101V17.0139C15.8731 17.0139 15.8469 17.0401 15.8356 17.0551C15.7081 17.1864 15.5731 17.3251 15.4269 17.4751C15.4081 17.4939 15.3894 17.5089 15.3744 17.5276C15.2394 17.6626 15.0969 17.7976 14.9506 17.9364C14.9169 17.9664 14.8869 18.0001 14.8531 18.0301C14.6956 18.1801 14.5306 18.3264 14.3619 18.4764C14.3244 18.5101 14.2869 18.5401 14.2531 18.5739C14.0769 18.7276 13.8969 18.8776 13.7206 19.0239C13.6869 19.0501 13.6494 19.0726 13.6119 19.0839C13.6006 19.0876 13.5894 19.0839 13.5781 19.0914C13.5481 19.0989 13.5219 19.1064 13.4919 19.1064C13.4919 19.1064 13.4881 19.1064 13.4844 19.1064C13.4619 19.1064 13.4394 19.0989 13.4169 19.0951C13.4019 19.0951 13.3906 19.0951 13.3756 19.0876C13.3381 19.0764 13.3006 19.0614 13.2706 19.0351C13.1319 18.9376 13.0756 18.7651 13.1244 18.6076C13.5631 17.3064 14.2756 15.7839 14.7294 15.0039C14.8456 14.8126 14.9581 14.6326 15.0706 14.4489C15.1531 14.3139 15.2394 14.1751 15.3219 14.0401C15.3594 13.9764 15.3969 13.9164 15.4381 13.8564C15.5844 13.6201 15.7344 13.3839 15.8769 13.1551V7.25264H13.0306C12.2656 7.25264 11.6394 6.63014 11.6394 5.86139V3.01514H1.64936C1.10186 3.01514 0.651855 3.46139 0.651855 4.01264V20.9176C0.651855 21.4651 1.09811 21.9151 1.64936 21.9151V21.9076ZM10.9869 10.7251H13.7356C14.2119 10.7251 14.6019 11.1114 14.6019 11.5914C14.6019 12.0714 14.2156 12.4576 13.7356 12.4576H10.9869C10.5106 12.4576 10.1206 12.0714 10.1206 11.5914C10.1206 11.1114 10.5069 10.7251 10.9869 10.7251ZM2.27186 9.01889L5.59436 5.95889C5.72936 5.83889 5.92811 5.83514 6.06311 5.95889L9.38561 9.01889C9.49061 9.11639 9.52436 9.26639 9.47186 9.39764C9.41936 9.53264 9.29186 9.61889 9.14935 9.61889H8.46311V12.1089C8.46311 12.3001 8.30936 12.4539 8.11811 12.4539H3.53561C3.34436 12.4539 3.19061 12.3001 3.19061 12.1089V9.61889H2.50436C2.36186 9.61889 2.23436 9.53264 2.18186 9.39764C2.12936 9.26264 2.16311 9.11639 2.26811 9.01889H2.27186ZM2.79311 14.0514H12.1419C12.6181 14.0514 13.0081 14.4376 13.0081 14.9176C13.0081 15.3976 12.6219 15.7839 12.1419 15.7839H2.79311C2.31686 15.7839 1.92686 15.3976 1.92686 14.9176C1.92686 14.4376 2.31311 14.0514 2.79311 14.0514ZM2.79311 17.3776H10.7506C11.2269 17.3776 11.6169 17.7639 11.6169 18.2439C11.6169 18.7239 11.2306 19.1101 10.7506 19.1101H2.79311C2.31686 19.1101 1.92686 18.7239 1.92686 18.2439C1.92686 17.7639 2.31311 17.3776 2.79311 17.3776Z",
    fill: "url(#paint0_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9832 12.0602H13.732C13.9907 12.0602 14.2045 11.8502 14.2045 11.5877C14.2045 11.3252 13.9945 11.1152 13.732 11.1152H10.9832C10.7245 11.1152 10.5107 11.3252 10.5107 11.5877C10.5107 11.8502 10.7207 12.0602 10.9832 12.0602Z",
    fill: "url(#paint1_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79306 18.7128H10.7506C11.0093 18.7128 11.2231 18.5028 11.2231 18.2403C11.2231 17.9778 11.0131 17.7678 10.7506 17.7678H2.79306C2.53431 17.7678 2.32056 17.9778 2.32056 18.2403C2.32056 18.5028 2.53056 18.7128 2.79306 18.7128Z",
    fill: "url(#paint2_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79306 15.3864H12.1418C12.4006 15.3864 12.6143 15.1764 12.6143 14.9139C12.6143 14.6514 12.4043 14.4414 12.1418 14.4414H2.79306C2.53431 14.4414 2.32056 14.6514 2.32056 14.9139C2.32056 15.1764 2.53056 15.3864 2.79306 15.3864Z",
    fill: "url(#paint3_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58436 9.42399V12.064H4.78811V10.519C4.78811 9.94899 5.25311 9.48399 5.82311 9.48399C6.39311 9.48399 6.85811 9.94899 6.85811 10.519V12.064H8.06186V9.42399C8.06186 9.31524 8.15186 9.22524 8.26061 9.22524H9.01811L5.81936 6.28149L2.62061 9.22524H3.37811C3.48686 9.22524 3.57686 9.31524 3.57686 9.42399H3.58436Z",
    fill: "url(#paint4_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8268 9.87402C5.4743 9.87402 5.18555 10.1628 5.18555 10.5153V12.0603H6.46805V10.5153C6.46805 10.1628 6.1793 9.87402 5.8268 9.87402Z",
    fill: "url(#paint5_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7581 8.10385C18.5281 9.79885 17.4368 11.4151 16.2331 13.3126C15.8843 13.8676 15.5243 14.4451 15.1531 15.0488L16.3456 15.8776C18.3256 13.3651 19.8143 11.3363 21.2768 9.16135L19.7618 8.1001L19.7581 8.10385Z",
    fill: "url(#paint6_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.938 4.22657C22.8517 4.16657 22.7317 4.18532 22.6642 4.26782C21.6217 5.59532 20.7667 6.72032 19.9905 7.78157L21.498 8.83157C22.2292 7.73657 22.9867 6.54782 23.8717 5.10782C23.928 5.01782 23.9055 4.89782 23.8155 4.83407L22.938 4.22282V4.22657Z",
    fill: "url(#paint7_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9543 15.3902C14.508 16.204 13.8705 17.599 13.488 18.7315C14.358 17.9927 15.3405 17.0215 15.918 16.3802C15.9818 16.3127 16.038 16.2452 16.0905 16.1815L14.9505 15.3865L14.9543 15.3902Z",
    fill: "url(#paint8_linear_3239_13478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0231 6.85522H15.5881L12.0256 3.29272V5.85772C12.0256 6.40897 12.4719 6.85522 13.0231 6.85522Z",
    fill: "url(#paint9_linear_3239_13478)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3239_13478",
    x1: 8.26415,
    y1: 3.31923,
    x2: 8.26415,
    y2: 20.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3239_13478",
    x1: 12.3576,
    y1: 11.1304,
    x2: 12.3576,
    y2: 11.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3239_13478",
    x1: 6.77169,
    y1: 17.783,
    x2: 6.77169,
    y2: 18.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3239_13478",
    x1: 7.46729,
    y1: 14.4566,
    x2: 7.46729,
    y2: 15.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3239_13478",
    x1: 5.81927,
    y1: 6.37453,
    x2: 5.81927,
    y2: 11.6281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3239_13478",
    x1: 5.82678,
    y1: 9.9092,
    x2: 5.82678,
    y2: 11.8955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3239_13478",
    x1: 18.2149,
    y1: 8.22523,
    x2: 18.2149,
    y2: 15.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3239_13478",
    x1: 21.9464,
    y1: 4.26606,
    x2: 21.9464,
    y2: 8.48182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3239_13478",
    x1: 14.7893,
    y1: 15.4403,
    x2: 14.7893,
    y2: 18.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3239_13478",
    x1: 13.8068,
    y1: 3.35004,
    x2: 13.8068,
    y2: 6.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3239_13478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.276855 0.461426)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenancy);
export default __webpack_public_path__ + "static/media/tenancy.d88a37b68c55879c1caed50eeda44f12.svg";
export { ForwardRef as ReactComponent };